// extracted by mini-css-extract-plugin
export default {"scoreContainer":"score_scoreContainer__P7Ehs"};